@if (shouldShow) {
  <div class="onboarding-guide" [class.collapsed]="isCollapsed">
    <!-- Header -->
    <div class="onboarding-header" (click)="toggleCollapse()">
      <div class="onboarding-header-content">
        <div class="onboarding-icon">
          <i class="fa fa-rocket"></i>
        </div>
        <div class="onboarding-title-section">
          <h6 class="onboarding-title">{{ 'companyOnboarding.title' | translate }}</h6>
          <div class="onboarding-progress">
            <div class="progress-bar-container">
              <div class="progress-bar-fill" [style.width.%]="progressPercent"></div>
            </div>
            <span class="progress-text">{{ completedCount }}/{{ totalCount }}</span>
          </div>
        </div>
      </div>
      <div class="onboarding-header-actions">
        <button class="btn-icon" (click)="toggleCollapse(); $event.stopPropagation()" [attr.aria-label]="isCollapsed ? 'Expand' : 'Collapse'">
          <i class="fa" [class.fa-chevron-up]="!isCollapsed" [class.fa-chevron-down]="isCollapsed"></i>
        </button>
        <button class="btn-icon btn-close-guide" (click)="dismissAll(); $event.stopPropagation()" [attr.aria-label]="'Close'">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Content (collapsible) -->
    @if (!isCollapsed) {
      <div class="onboarding-content">
        <p class="onboarding-subtitle">{{ 'companyOnboarding.subtitle' | translate }}</p>

        <div class="onboarding-items">
          @for (item of visibleItems; track item.id) {
            <div class="onboarding-item" (click)="onItemClick(item)">
              <div class="item-icon" [class.completed]="item.completed">
                <i class="fa" [ngClass]="item.icon"></i>
              </div>
              <div class="item-content">
                <span class="item-title">{{ item.title | translate }}</span>
                <span class="item-description">{{ item.description | translate }}</span>
              </div>
              <div class="item-actions">
                <button class="btn-dismiss" (click)="dismissItem(item, $event)" [attr.aria-label]="'Dismiss'">
                  <i class="fa fa-times"></i>
                </button>
                <i class="fa fa-chevron-right item-arrow"></i>
              </div>
            </div>
          }
        </div>

        @if (visibleItems.length === 0) {
          <div class="onboarding-complete">
            <i class="fa fa-check-circle"></i>
            <span>{{ 'companyOnboarding.allComplete' | translate }}</span>
          </div>
        }
      </div>
    }
  </div>
}
